<template>
  <div class="eight_section">
    <h1>成为开发者</h1>
    <div class="step_wrapper">
      <div class="step_item">
        <img src="../../assets/home/kafa-1.png" alt="step1" />
        <p>注册账号</p>
      </div>
      <div class="step_item">
        <img src="../../assets/home/kafa-2.png" alt="step2" />
        <p>开发者认证</p>
      </div>
      <div class="step_item">
        <img src="../../assets/home/kafa-3.png" alt="step3" />
        <p>申请Key</p>
      </div>
      <div class="step_item">
        <img src="../../assets/home/kafa-4.png" alt="step4" />
        <p>集成产品与服务</p>
      </div>
    </div>

    <div class="btn_wrapper" @click="openRegister">
      <button>立即注册</button>
    </div>
  </div>
</template>

<script>
import event from '@/utils/event';
export default {
  methods: {
    openRegister() {
      event.$emit('openRegister');
    },
  },
};
</script>

<style lang="scss" scoped>
.eight_section {
  background-image: url('../../assets/home/8.webp');
  height: 600px;
  h1 {
    margin: 0;
    padding: 60px 0px;
    text-align: center;
    font-size: 28px;
    font-weight: 400;
    color: #0d0e24;
  }
  .step_wrapper {
    width: 828px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    p {
      text-align: center;
      font-size: 16px;
      font-weight: 300;
      color: #0d0e24;
      margin-top: 20px;
    }
  }
  .btn_wrapper {
    display: block;
    width: 250px;
    height: 50px;
    margin: 0 auto;
    button {
      margin-top: 80px;
      text-align: center;
      width: 100%;
      height: 100%;
      background: #ffffff;
      border: 1px solid #0350b0;
      border-radius: 25px;
      &:hover {
        background-color: rgba(255, 255, 255, 0.5);
      }
    }
  }
}
</style>